/**
 * PipelineEmptyState - Shown when the pipeline has no jobs.
 * Displays a welcoming message and a CTA to add the first job.
 */

import { ExtensionPrompt } from '@/components/ExtensionPrompt';

interface PipelineEmptyStateProps {
  onAddJob: () => void;
}

export function PipelineEmptyState({ onAddJob }: PipelineEmptyStateProps) {
  return (
    <div className="pipeline-empty">
      {/* Briefcase icon */}
      <svg
        className="pipeline-empty__icon"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>

      <h2 className="pipeline-empty__heading">Start your job search</h2>
      <p className="pipeline-empty__subtext">
        Add jobs manually, paste a job description for AI parsing, or install the Chrome extension
        to auto-save from LinkedIn, Indeed, and 30+ job boards.
      </p>

      <button
        onClick={onAddJob}
        className="inline-flex items-center justify-center font-medium rounded-lg transition-colors bg-primary text-white hover:bg-primary-dark px-6 py-3 text-base shadow-sm"
      >
        <svg
          className="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        Add Job
      </button>

      <div className="mt-6 w-full max-w-md">
        <ExtensionPrompt variant="pipeline-empty" />
      </div>
    </div>
  );
}
